module.exports = ".phone-number-li {\n    cursor: default;\n    background-color: white;\n    text-align:right;\n}\n\n.phone-number-type-li {\n    cursor: default;\n    background-color: white;\n    color: #26273B;\n}\n\n.phone-number-group-li {\n    margin-top: 3px;\n}\n\n.menu-item {\n    cursor: pointer;\n}\n\nsmall {\n    color: rgb(153, 153, 153)\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/common/phone-numbers/phone-numbers.component.css
// module id = ./src/app/organization/components/common/phone-numbers/phone-numbers.component.css
// module chunks = main